import React from 'react';
import Console from '../../../../lib/debug';

const PreviewProgram = props => {
    Console.render('designer.PreviewProgram');
    let program = props.program;
    let programInfo = null;
    if (program.isSubscription) {
        programInfo = <span className="program-weeks">Team Subscription</span>;
    } else {
        programInfo = (
            <span className="program-weeks">
                {program.lengthWeeks ? `Weeks: ${program.lengthWeeks}` : ''}
            </span>
        );
    }
    let descriptionHTML = (
        <div dangerouslySetInnerHTML={{ __html: program.description }} />
    );

    return (
        <div className="Preview-content">
            <div className="new-item-preview item-preview show">
                <div className="program-preview">
                    <div className="information">
                        <span className="program-title">{program.title}</span>
                        <div className="layout-row">
                            <img src={program.logo} alt={program.title} />
                            <div className="layout-column">
                                <span className="program-difficulty">
                                    <strong>{program.difficulty}</strong>
                                </span>
                                {programInfo}
                            </div>
                        </div>
                        <div className="program-description">
                            {descriptionHTML}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PreviewProgram;
